<div class="assets radius-m white-bg dropdown-shadow p-6" id="asset-container" [formGroup]="assets">
    <div class="assets-container">
        <div class="platform-panel">
            <div class="platform-fields">
                <img [ngClass]="assetsService.assetsSpinnerState ? 'disable-action':'enable-action'"
                    src="assets/asset_host/left-arrow.svg" (click)="moveplatformlist(-1)">
                <div #platform_list class="platform-list content-m primary-text"
                    [ngClass]="data[1].disable || assetsService.assetsSpinnerState ?'disable-platform':'enable-platform'">
                    <ng-container *ngFor="let platforms of platformdata; let i = index">
                        <span class="chips-default px-2 " tabindex="-1" (click)="selectPlatform_click(platforms)" scrolltoelem
                            [isvalue]="platform.value == platforms.value"
                            [ngClass]="{'selected-platform chips-active': platform.value == platforms.value}">
                            {{platforms.disp}}
                        </span>
                    </ng-container>
                </div>
                <img [ngClass]="assetsService.assetsSpinnerState ? 'disable-action':'enable-action'"
                    src="assets/asset_host/right-arrow.svg" (click)="moveplatformlist(1)">
            </div>
        </div>
        <!-- <div class="platform-search"> -->
        <div class="platform-hosts-selected primary-text content-m ml-2 mr-4">
            {{assetslabels[0]}}
            <div class="selected-tags-group" *ngIf="toggleControl.value">
                <ng-container *ngFor="let tag of limitNoOfItems(selectedTagsArray,5); let i = index">
                    <span class="selected-tag px-2 chips-active content-m">
                        <span class="dot mr-2 content-m" [ngStyle]="tagChipColor(tag)"></span>
                        <span class="seltext mr-2 content-m" [tooltip]="tag.disp">{{tag.disp}}</span>
                        <span class="sellength mr-2 content-m"></span>
                        <img src="assets/alerts/close.svg" width="12" height="12" (click)="clearTagItem(tag)">
                    </span>
                </ng-container>
                <span *ngIf="selectedTagsArray.size >=6" class="showmore px-2 chips-active"
                    (click)="openMoreHosts_click(source,moreOrigin)">more..
                    <span class="more-num" #moreOrigin>5+</span>
                </span>
                <ng-template #source>
                    <div class="source-container content-m white-bg dropdown-shadow primary-text">
                        <span *ngFor="let src of remainingItems(selectedTagsArray,5); let i = index">
                            <span class="dot" [ngStyle]="tagChipColor(src)"></span>
                            <span class="text">{{src.disp| limitCharacter:8}}</span>
                            <img class="content-s ml-5" src="assets/alerts/close.svg" width="10" height="10" (click)="clearTagItem(src)">
                        </span>
                    </div>
                </ng-template>
            </div>
        </div>
        <div class="platform-hosts">
            <ng-container *ngIf="assetsService.assetsSpinnerState">
                <div class="body-bottom-spinner">
                    <mat-spinner class="spinner" diameter=20></mat-spinner>
                </div>
            </ng-container>
            <ul class="content-m primary-text" *ngIf="!toggleControl.value && !assetsService.assetsSpinnerState">
                <ng-container>
                    <ng-container *ngFor="let host of selectedHostsArray ; let i = index" formGroupName="totalHosts">
                        <li class="pt-5" (click)="selectHost_click(host)">
                            <label class="checkbox-container" [tooltip]="host.value">{{host.disp}}
                                <span class="dot" *ngIf="toggleControl.value" [style.background-color]="blue"></span>
                                <input type="checkbox" [formControlName]="host.value" (click)="$event.stopPropagation()">
                                <span class="checkmark"></span>
                            </label>
                        </li>
                    </ng-container>
                </ng-container>
                <!-- message to be shown if no result for searched values -->
                <li *ngIf="selectedHostsArray.length == 0" class="no-result content-xl primary-text">{{assetsService.lables.noresult}}</li>
            </ul>
            <ul *ngIf="toggleControl.value && !assetsService.assetsSpinnerState">

                <ng-container *ngFor="let host of tagsHost">
                    <li class="pt-5" #hosts>
                        <label class="checkbox-container" [tooltip]="host.hostname"
                            (click)="hostToggle_click(host)">{{host.hostname}}
                            <span class="dot" [ngStyle]="tagsStructure|colorPicker:host.member"></span>
                            <input type="checkbox" [checked]="host.selected" (click)="$event.stopPropagation()">
                            <span class="checkmark"></span>
                        </label>
                    </li>
                </ng-container>

                <li *ngIf="!tagsHost.length" class="no-result">{{assetsService.lables.noresult}}</li>
            </ul>
        </div>
        <div class="assetsSubmit">
            <!-- to close the dropdown -->
            <button mat-button class="cancel"
                [ngClass]="assetsService.assetsSpinnerState ? 'disable-action':'enable-action'" (click)="formCancel()"
                tabindex="0">{{assetsService.lables.cancel}}</button>
            <!-- to apply the selected hosts for search -->
            <button mat-button class="submit"
                [ngClass]="assetsService.assetsSpinnerState ? 'disable-action':'enable-action'" (click)="formSubmit()"
                tabindex="1">{{assetsService.lables.apply}}</button>
        </div>
    </div>
    <div class="tags-container">
        <div class="tags-header px-6 py-2">
            <div class="tag-header-col-1 content-m primary-text bold-text">
                <p class="m-0">{{assetslabels[1]}}</p>
                <label class="switch">
                    <input type="checkbox" formControlName="toggleControl">
                    <span class="slider round"></span>
                </label>
                <p class="m-0">{{assetslabels[2]}}</p>
            </div>
            <p class="clear-btn selectable-text content-l bold-text" [ngClass]="assetsService.assetsSpinnerState ? 'disable-action':'enable-action'"
                (click)="clearBtn()">Clear</p>
        </div>
        <div class="tags-body px-8 py-2">
            <div class="tags-body-row-1">
                <div class="tags-body-row-l-col-1">
                    <!-- <label class="checkbox-container" *ngIf="!toggleControl.value"> -->
                    <label class="checkbox-container" *ngIf="false">

                        <input type="checkbox" formControlName="selecteAll" (click)="$event.stopPropagation()">
                        <span class="checkmark"></span>
                    </label>
                </div>
                <div class="custom-search">
                    <!-- To search hosts -->
                    <img src="assets/search-small.svg">
                    <input type="search" placeholder="Type to search here" formControlName="searchValue">
                </div>
            </div>

            <ul *ngIf='toggleControl.value' class='tags-section content-m primary-text'>
                <ng-container *ngIf="assetsService.assetsSpinnerState">
                    <div class="body-bottom-spinner">
                        <mat-spinner class="spinner" diameter=20></mat-spinner>
                    </div>
                </ng-container>
                <ng-container *ngIf="!assetsService.assetsSpinnerState">
                    <ng-container formGroupName="totalTags">
                        <ng-container *ngFor="let category of tagsCategoriesObj | keyvalue">
                            <li class="pt-5" *ngIf="category.value.length>0" [formGroupName]="category.key" class="label">
                                {{category.key}}
                                <ng-container *ngFor="let tag of category.value">
                            <li class="pt-5" (click)="selectTags_click(category.key,tag)">
                                <span class="checkbox-container" [tooltip]="tag.disp">{{tag.disp}}
                                    <input type="checkbox" [formControlName]="tag.disp" checked
                                        (click)="$event.stopPropagation()">
                                    <span class="checkmark"></span>
                                </span>
                            </li>
                        </ng-container>
                        </li>
                    </ng-container>
                    <li *ngIf="tagsCategoriesObj|novalueAsset:shownohostmsg" class="no-tags content-m bold-text primary-text pl-3">{{assetslabels[3]}}</li>
                </ng-container>
                </ng-container>

            </ul>
            <ul *ngIf='!toggleControl.value' class='tags-section content-m primary-text'>
                <ng-container *ngIf="assetsService.assetsSpinnerState">
                    <div class="body-bottom-spinner">
                        <mat-spinner class="spinner" diameter=20></mat-spinner>
                    </div>
                </ng-container>
                <ng-container *ngIf="!assetsService.assetsSpinnerState">
                    <ng-container *ngFor="let host of filteredHostArray; let i = index">
                        <li class="pt-5" tabindex="-1" (click)="selectHost_click(host)" #hostLabel>
                            <span class="checkbox-container" [formGroup]="totalHosts" [tooltip]="host.disp">{{host.disp}}
                                <input type="checkbox" [formControlName]="host.value"
                                    (click)="$event.stopPropagation()">
                                <span class="checkmark"></span>
                            </span>
                        </li>
                    </ng-container>
                    <li *ngIf="!filteredHostArray.length" class="no-tags ">{{assetslabels[4]}}</li>
                </ng-container>
            </ul>
        </div>
    </div>
</div>


<!-- <div class="chip-container">
    <div class="chip">None</div>
    <div class="chip">None selected</div>
    <div class="chip">3 selected</div>
</div> -->